<template>
    <v-list-tile v-if="!isDivider" @click="action">
      <v-list-tile-action v-if="icon">
        <v-icon>{{icon}}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content :style="!icon ? {paddingLeft: '15px'} : {}">
        <v-list-tile-title>
          <v-badge color="red" v-model="show" class="uxl-badge">
            <span slot="badge">&nbsp;</span>
            {{title}}
          </v-badge>
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-list-tile v-else>
      <v-list-tile-title class="isDivider-text">{{ title }}</v-list-tile-title>
    </v-list-tile>
</template>

<script>

export default {
  name: 'DrawerOption',
  props: ['isDivider', 'action', 'icon', 'title', 'isHighlighted'],
  computed: {
    show: function () {
      if (this.isHighlighted) {
        return this.isHighlighted()
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss">
.isDivider-text {
  font-weight: bold;
  letter-spacing: .5px;
}
</style>



// WEBPACK FOOTER //
// src/components/DrawerOption.vue